// extracted by mini-css-extract-plugin
export default {"changeBorder":"EditableGroup_changeBorder__xuszN"};